import * as ActionTypes from "../Types/ActionTypes";

export const DocumentMasters = (
  state = {
    isLoading: true,
    errMess: null,
    documentMasters: [],
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.FETCH_DOCUMENTMASTERS:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        documentMasters: action.payload,
      };

    case ActionTypes.DOCUMENTMASTERS_LOADING:
      return {
        ...state,
        isLoading: true,
        errMess: null,
        documentMasters: [],
      };

    case ActionTypes.DOCUMENTMASTERS_FAILED:
      return {
        ...state,
        isLoading: false,
        errMess: action.payload,
        documentMasters: [],
      };

    default:
      return state;
  }
};
